console.warn(`加载模块 ${import.meta.env['VITE_MF_NAME']}. 构建时间: ${__BUILD_TIME__}`)

if (!window.__MF_HOST_NAME__) {
  console.warn(`加载主模块 ${import.meta.env['VITE_MF_NAME']}`)
  window.__MF_HOST_NAME__ = import.meta.env['VITE_MF_NAME']
  window.__MF_HOST_ENV__ = import.meta.env
  import('@/main.js')
}
